import { useState } from "react";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import defaultImage from "../../images/attendee_initial.svg";
import stoppedImage from "../../images/progress_stop_image.svg";
import InformSummarizeModal from "../../components/InformSummarizeModal";
import { SUMMARIZE_STATES } from "../../constants";
import { DEFAULT_VIEW_TEXT } from "./home.constants";
import LogManager from "../../utils/logManager";

/**
 * DefaultView - Shared view for initial state and session ended state.
 * Used for organizers (with Start button), attendees (no button), and session ended.
 *
 * Automatically determines image, title, and subtitle based on summarizeState.
 * showStartButton controls whether the Start button and modal are rendered.
 * onStart starts summarization (from the summarization controller).
 */
const DefaultView = ({
  summarizeState,
  summarizeClickCount,
  onStart,
  // Customizable display props (override auto-detection if provided)
  showStartButton = true,
}) => {
  // Determine display based on summarize state
  const isSessionEnded = summarizeState === SUMMARIZE_STATES.STOPPED;
  const image = isSessionEnded ? stoppedImage : defaultImage;
  const title = isSessionEnded ? DEFAULT_VIEW_TEXT.STOPPED_TITLE : DEFAULT_VIEW_TEXT.DEFAULT_TITLE;
  const displaySubtitle = isSessionEnded ? DEFAULT_VIEW_TEXT.STOPPED_SUBTITLE : (!showStartButton ? DEFAULT_VIEW_TEXT.ATTENDEE_SUBTITLE : null);

  const [isInformSummarizeModalOpen, setIsInformSummarizeModalOpen] = useState(false);

  const handleStartClick = () => {
    LogManager.metric("Summarization_StartButton_Click", 1);
    if (summarizeClickCount === 0) {
      setIsInformSummarizeModalOpen(true);
    } else {
      startSummarize();
    }
  };

  const onModalConfirmed = () => {
    setIsInformSummarizeModalOpen(false);
    startSummarize();
  };

  const startSummarize = () => {
    onStart();
  };

  return (
    <>
      <Row height="48px"/>
      <Row spacing="none">
        <Column width="13px"/>
        <img src={image} alt={title} />
      </Row>
      <Row spacing="none">
        <Column width="67px"/>
        <Column alignmentHorizontal="start" spacing="none" width="238px">
          <Row height="24px"/>
          <Text type="h50" alignment="center">
            {title}
          </Text>
          {displaySubtitle && (
            <>
              <Row height="8px"/>
              <Text type="b200" color="secondary">
                {displaySubtitle}
              </Text>
            </>
          )}
          {showStartButton && (
            <>
              <Row height="24px"/>
              <Button onClick={handleStartClick} minWidth="194px" size="small">
                Start
              </Button>
            </>
          )}
        </Column>
      </Row>
      {showStartButton && (
        <InformSummarizeModal
          isOpen={isInformSummarizeModalOpen}
          onClose={() => setIsInformSummarizeModalOpen(false)}
          onConfirm={onModalConfirmed}
        />
      )}
    </>
  );
};

export default DefaultView;
